import { DISNEY_LAYOUTS } from './disney';
import { MACRO_LAYOUTS } from './bcomacro';
import type { CanvasJSON } from '@doer/frontend-components/creativity-editor';
interface Asset {
  name: string;
  url: string;
}

export type LayoutAssets = Record<string, Asset>;
export type PieceReplaceOptions = Record<string, string[]>;

export interface Layout {
  name: string;
  canvas: CanvasJSON;
  assets: LayoutAssets;
  replaceOptions: PieceReplaceOptions;
}

export const CLIENTS_CONFIG = {
  macro: {
    name: 'Macro',
    layouts: ['macro0001', 'macro0002'] as const
  },

  disney: {
    name: 'Disney',
    layouts: ['disney0000'] as const
  }
};

export const LAYOUTS_CONFIG: Record<string, Layout> = {
  macro0001: {
    name: '9:16 - Texto, Imagen y Logo 1',
    canvas: MACRO_LAYOUTS[0],
    assets: {
      'asset-00': { name: 'Asset Original', url: 'demo/macro/01/asset-00.png' },
      'extra-01': { name: 'Extra 1', url: 'demo/macro/01/extra-01.png' },
      'extra-02': { name: 'Extra 2', url: 'demo/macro/01/extra-02.png' }
    },
    replaceOptions: {
      'asset-00': ['asset-00', 'extra-01', 'extra-02']
    }
  },

  macro0002: {
    name: '9:16 - Texto, Imagen y Logo 2',
    canvas: MACRO_LAYOUTS[1],
    assets: {
      'asset-00': { name: 'Asset Original', url: 'demo/macro/02/asset-00.png' },
      'extra-00': { name: 'Extra', url: 'demo/macro/02/extra-00.png' }
    },
    replaceOptions: {
      'asset-00': ['asset-00', 'extra-00']
    }
  },

  disney0000: {
    name: '9:16 - Fondo, Personaje, Logo, Texto',
    canvas: DISNEY_LAYOUTS[0],
    assets: {
      background: { name: 'Fondo', url: 'demo/disney/02/background.png' },
      hulu: { name: 'Logo Hulu', url: 'demo/disney/02/hulu.png' },
      character: { name: 'Personaje', url: 'demo/disney/02/character.png' },
      logo: { name: 'Logo Disney', url: 'demo/disney/02/logo.png' }
    },
    replaceOptions: {
      background: ['background'],
      hulu: ['hulu'],
      character: ['character'],
      logo: ['logo']
    }
  }
};

export type ClientId = keyof typeof CLIENTS_CONFIG;
export type LayoutId = keyof typeof LAYOUTS_CONFIG;
